<ui2-checkbox [name]="'normalize'" [(ngModel)]="model" (change)="change()">{{
  'signals-ng-visualization-tab.configPanel.ui.normalize' | translate
}}</ui2-checkbox>
